import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=11cc2f9e&scoped=true&"
import script from "./checkbox.vue?vue&type=script&lang=js&"
export * from "./checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cc2f9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11cc2f9e')) {
      api.createRecord('11cc2f9e', component.options)
    } else {
      api.reload('11cc2f9e', component.options)
    }
    module.hot.accept("./checkbox.vue?vue&type=template&id=11cc2f9e&scoped=true&", function () {
      api.rerender('11cc2f9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/input/checkbox.vue"
export default component.exports